/**
 * Date helpers for the nutrition plan. The week helpers (`todayISO`,
 * `mondayOf`, `formatWeekLabel`, …) are shared with the workout plan and live
 * in `programming/shared/planDates`; they are re-exported here so the
 * nutrition code keeps one import. The meal-time helpers below are
 * nutrition-only.
 */
export {
  addDaysISO,
  formatWeekLabel,
  mondayOf,
  parseISODate,
  thisWeekMonday,
  toISODate,
  todayISO,
} from "../../shared/planDates";

/** "08:00:00" → "08:00". Returns "" for empty input. */
export const formatMealTime = (time: string | undefined | null): string => {
  if (!time) return "";
  const [h = "", m = ""] = time.split(":");
  return h && m ? `${h.padStart(2, "0")}:${m.padStart(2, "0")}` : "";
};

/** "HH:MM:SS" (or "HH:MM") → minutes since midnight. Invalid input → 0. */
export const timeToMinutes = (time: string | undefined | null): number => {
  if (!time) return 0;
  const [h, m] = time.split(":").map((part) => parseInt(part, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return 0;
  return h * 60 + m;
};
